import type { ParameterDimensionDefinitionInOut } from '@festina/configuration-general-types/configuration'
import { useTranslate, useTranslateEnum } from '@festina-life/ui/hooks'
import cx from 'classnames'

type Props = {
  data: ParameterDimensionDefinitionInOut
  isCentered: boolean
}

export const ParameterDimensionTypeViewer = ({ data, isCentered }: Props) => {
  const translateEnum = useTranslateEnum()
  const translate = useTranslate()

  return (
    <div
      className={cx('flex size-full flex-row items-center gap-x-2', {
        'justify-center': isCentered,
      })}
    >
      <div>
        {translateEnum(
          'parameter.enum.ParameterDimensionType',
          data.dimensionType,
        )}
      </div>
      {data.isRange && (
        <div className="opacity-50">
          {translate('parameter.dimension.range')}
        </div>
      )}
    </div>
  )
}
